import React, { useRef } from 'react'
import { func, string, shape } from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useStatusOverlay } from '@fs/zion-ui'
import handleFileUploadAttempt from '../../shared/helpers/upload'

export default function HiddenFileInput({ inputRef, onFileAccepted, formTestId, inputTestId }) {
  const [t] = useTranslation()
  const formRef = useRef()
  const showStatusOverlay = useStatusOverlay()

  const handleChange = (e) => {
    const f = e.target.files
    if (f.length > 0) {
      handleFileUploadAttempt({
        fileForm: formRef.current,
        fileInputName: 'imgInput',
        fileType: f[0]?.type,
        fileSize: f[0]?.size,
        uploadCallback: onFileAccepted,
        wrongFileTypeHandler: () => {
          showStatusOverlay({
            message: t('caf.upload.invalid-file-type', 'The file type is not supported. Please upload an image file.'),
            type: 'error',
          })
        },
        fileTooLargeHandler: () => {
          showStatusOverlay({
            message: t('caf.upload.file-too-large', 'The file is too large. Use a file smaller than 15 Megabytes'),
            type: 'error',
          })
        },
      })
    }
  }

  return (
    <form data-testid={formTestId} ref={formRef}>
      <input
        css={{ display: 'none' }}
        ref={inputRef}
        name="imgInput"
        data-testid={inputTestId}
        onChange={handleChange}
        type="file"
        accept="image/*"
      />
    </form>
  )
}

HiddenFileInput.propTypes = {
  inputRef: shape({ current: shape({}) }),
  onFileAccepted: func.isRequired,
  formTestId: string,
  inputTestId: string,
}
